module.exports = __webpack_public_path__ + "static/img/goRecharge.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/goRecharge.png
// module id = 530
// module chunks = 0